// src/pages/Portfolio.jsx
import React from 'react';
import Seo from '../components/Seo';
import BreadcrumbJsonLd from '../components/BreadcrumbJsonLd';

import Hero from '../components/Home/Hero';
import PortfolioSection from '../components/Portfolio/PortfolioSection';

export default function PortfolioPage() {
  return (
    <>
      {/* 1. SEO-meta voor deze pagina */}
      <Seo
        title="Portfolio | Online Growth Club"
        description="Bekijk onze afgeronde projecten en zie hoe we bedrijven helpen groeien met effectieve websites en online marketing."
        path="/portfolio"
      />

      {/* 2. Breadcrumb structured data */}
      <BreadcrumbJsonLd
        list={[
          { name: 'Home',      item: 'https://onlinegrowthclub.nl/' },
          { name: 'Portfolio', item: 'https://onlinegrowthclub.nl/portfolio' }
        ]}
      />

      {/* 3. Pagina-inhoud */}
      <Hero />
      <PortfolioSection />
    </>
  );
}
